<script lang="ts">
    import { features, fm } from './features';
    import Switch from '../Switch.svelte';

    function getBacklogLink(number: number): string {
        let hrefPrefix = 'https://tools.automapa.pl/backlog#';
        return `<a href=${hrefPrefix}${number} target="_blank">#${number}</a>`;
    }

    function replaceAllNumberWithLink(text: string): string {
        return text.replace(/#(\d\d\d\d+)/g, (match, number) => getBacklogLink(parseInt(number)));
    }
</script>

<div style="display: flex; row-gap: 8px; flex-direction: column;">
    {#each Object.keys($fm.getFeatures()) as featureId}
        <Switch
            disabled={$fm.isDisabled(featureId)}
            checked={$fm.isEnabled(featureId)}
            label={replaceAllNumberWithLink($fm.getDescription(featureId))}
            on:change={e => {
                console.log('onChange', e);
                $fm.setEnabled(featureId, e.detail.checked);
                $fm = $fm;
                $features = $fm.getFeatures();
            }}
        />
    {/each}
</div>
